var useHelpers = function () {
    var sorter = function (a, b, isAscedning) {
        if (isAscedning === void 0) { isAscedning = true; }
        var _a = typeof a === 'string' ? a.toLocaleLowerCase() : a;
        var _b = typeof b === 'string' ? b.toLocaleLowerCase() : b;
        if (_a === undefined || _b === undefined)
            return 0;
        else if (_a < _b)
            return isAscedning ? -1 : 1;
        else if (_a > _b)
            return isAscedning ? 1 : -1;
        return 0;
    };
    return { sorter: sorter };
};
export default useHelpers;
